import React from "react";
import OnePlatform from "../../../assets/one-platform-image.png";
import PlatformIcon1 from "../../../assets/platform-icon-1.png";
import PlatformIcon2 from "../../../assets/platform-icon-2.png";
import PlatformIcon3 from "../../../assets/platform-icon-3.png";
import PlatformIcon4 from "../../../assets/platform-icon-4.png";
import PlatformIcon5 from "../../../assets/platform-icon-5.png";
import PlatformIcon6 from "../../../assets/platform-icon-6.png";
import PlatformIcon7 from "../../../assets/platform-icon-7.png";
import PlatformIcon8 from "../../../assets/platform-icon-8.png";

const OnePlatformSection = ({ acfData }) => {
  const fallbackFeatures = [
    {
      icon: PlatformIcon1,
      title: "Tested and Proven Software",
      description:
        "Software developed and tested for over three years, designed by team with four decades of combined experience in every aspect of the hospitality industry.",
    },
    {
      icon: PlatformIcon2,
      title: "Revenue-Driven Pricing Tools",
      description:
        "Dynamic pricing, offering single or multiple rates across any date range. Designed with the full functionality of a revenue management platform.",
    },
    {
      icon: PlatformIcon3,
      title: "Real-Time Custom Reports",
      description:
        "Best in industry report features with real time, customized reporting.",
    },
    {
      icon: PlatformIcon4,
      title: "Seamless All-in-One Platform",
      description:
        "Ease of use and simplicity. PMS, POS, housekeeping management and booking all within one platform.",
    },
    {
      icon: PlatformIcon5,
      title: "Affiliate Portal & Management",
      description:
        "Proprietary affiliate portal allows for easy tracking, bookkeeping and reporting for all tour affiliates. Allows tour operators to block and release time slots for affiliates.",
    },
    {
      icon: PlatformIcon6,
      title: "One-Stop Guest Booking",
      description:
        "Guests may select their hotel room, reserve a table and book a tour or event for their trip to Native lands - all in one place.",
    },
    {
      icon: PlatformIcon7,
      title: "256-Bit AES Protection",
      description:
        "100% safe and secure. 256 bit AES encryption with every transaction",
    },
    {
      icon: PlatformIcon8,
      title: "Native-Owned SaaS Leader",
      description:
        "Along with a host of other features not mentioned, we are the only 100% Native-owned SaaS company on the market.",
    },
  ];

  const features =
    acfData?.["pms_+_pos_+_booking_=_one_platform_items"]?.length > 0
      ? acfData["pms_+_pos_+_booking_=_one_platform_items"].map((item, index) => ({
          icon: item.one_platform_item_icon?.url || fallbackFeatures[index]?.icon,
          title: item.one_platform_item_title || fallbackFeatures[index]?.title,
          description: item.one_platform_item_description || fallbackFeatures[index]?.description,
        }))
      : fallbackFeatures;

  const SecTitle =
    acfData?.pms_pos_booking_one_platform || "PMS + POS + Booking = One Platform";

  const platformImage =
    acfData?.pms_pos_booking_one_platform_image?.url || OnePlatform;

  return (
    <section className="py-12 lg:pt-22 lg:pb-24">
      <div className="w-full max-w-[1570px] px-4 mx-auto">
        <div className="flex flex-wrap -mx-4 gap-y-8 lg:gap-y-11">
          <div className="w-full max-w-full px-4">
            {SecTitle && (
              <h2 className="text-[30px] md:text-[40px] lg:text-[52px] font-normal leading-none text-[#5fa3b2] text-center">
                {SecTitle}
              </h2>
            )}
          </div>
          <div className="w-full max-w-full px-4">
            <img
              src={platformImage}
              alt="PMS + POS + Booking = One Platform"
              className="w-auto mx-auto"
              height="1416"
              width="483"
            />
          </div>
          {/* Mobile View */}
          <div className="lg:hidden w-full max-w-full px-4">
            <ul className="divide-y divide-[#DDDDDD]">
              {features.map((feature, index) => {
                const isFirst = index === 0;
                const isLast = index === features.length - 1;
                const listItemClass = isFirst
                  ? "pb-6 sm:pb-9"
                  : isLast
                  ? "pt-6 sm:pt-9"
                  : "py-6 sm:py-9";

                return (
                  <li className={listItemClass} key={index}>
                    <div className="flex items-start min-w-0 gap-x-4 sm:gap-x-6">
                      <img
                        src={feature.icon}
                        alt={feature.title}
                        className="max-w-[40px] sm:max-w-full h-auto"
                        height="54"
                        width="54"
                      />
                      <div className="flex flex-col gap-2 sm:gap-3">
                        <h3 className="text-[22px] sm:text-[26px] font-normal leading-8 text-[#192020]">
                          {feature.title}
                        </h3>
                        <p className="text-base sm:text-lg font-light leading-6 sm:leading-7 text-[#192020]">
                          {feature.description}
                        </p>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
          {/* Desktop View Left */}
          <div className="hidden lg:block w-full lg:w-1/2 max-w-full px-4">
            <ul className="divide-y divide-[#DDDDDD] max-w-[645px]">
              {features.slice(0, 4).map((feature, index, arr) => {
                const isFirst = index === 0;
                const isLast = index === arr.length - 1;
                const listItemClass = isFirst
                  ? "pb-9"
                  : isLast
                  ? "pt-9"
                  : "py-9";

                return (
                  <li className={listItemClass} key={index}>
                    <div className="flex items-start min-w-0 gap-x-6">
                      <img
                        src={feature.icon}
                        alt={feature.title}
                        className="h-auto"
                        height="54"
                        width="54"
                      />
                      <div className="flex flex-col gap-3">
                        <h3 className="text-[26px] font-normal leading-8 text-[#192020]">
                          {feature.title}
                        </h3>
                        <p className="text-lg font-light leading-7 text-[#192020]">
                          {feature.description}
                        </p>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
          {/* Desktop View Right */}
          <div className="hidden lg:block w-full lg:w-1/2 max-w-full px-4">
            <ul className="divide-y divide-[#DDDDDD] max-w-[645px]">
              {features.slice(4).map((feature, index, arr) => {
                const isFirst = index === 0;
                const isLast = index === arr.length - 1;
                const listItemClass = isFirst
                  ? "pb-9"
                  : isLast
                  ? "pt-9"
                  : "py-9";

                return (
                  <li className={listItemClass} key={index}>
                    <div className="flex items-start min-w-0 gap-x-6">
                      <img
                        src={feature.icon}
                        alt={feature.title}
                        className="h-auto"
                        height="54"
                        width="54"
                      />
                      <div className="flex flex-col gap-3">
                        <h3 className="text-[26px] font-normal leading-8 text-[#192020]">
                          {feature.title}
                        </h3>
                        <p className="text-lg font-light leading-7 text-[#192020]">
                          {feature.description}
                        </p>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OnePlatformSection;
